import { render, staticRenderFns } from "./CandidateMedia.vue?vue&type=template&id=29d222fc"
import script from "./CandidateMedia.vue?vue&type=script&lang=js"
export * from "./CandidateMedia.vue?vue&type=script&lang=js"
import style0 from "./CandidateMedia.vue?vue&type=style&index=0&id=29d222fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports